














































import Vue from 'vue';
import { ELanguage } from '@ringana/configs';
import { IMediaElementDto } from '@/common/interfaces/media.interface';
import { EMediaType } from '@/common/enums/media.enum';
import TIcons from '@/types/TIcons';
import { IWPValue, IValuesSectionData } from '@/common/interfaces/products.interface';
import config from '../../../../config';
import ImageWithErrorMessage from '@/components/newsingleproductpage/subcomponents/imagewitherrormessage/ImageWithErrorMessage.vue';

interface IValuesSectionComponent {
  fallbackImage: string;
  icons: typeof TIcons;
  transformedValues: IMediaElementDto[];
}

export default Vue.extend({
  name: `ProductPageValuesSection`,
  components: {
    ImageWithErrorMessage,
  },
  data(): IValuesSectionComponent {
    return {
      fallbackImage: config.images.fallbackImage,
      icons: TIcons,
      transformedValues: [],
    };
  },
  computed: {
    linkMoreInformations(): string {
      return config.ringana.paths.values;
    },
  },
  props: {
    isCosmeticsProduct: {
      default: false,
      type: Boolean,
    },
    values: {
      required: true,
      type: Array as () => IValuesSectionData[] | IWPValue[],
    },
  },
  async mounted(): Promise<void> {
    if(this.isWPValue(this.values)) {
      this.transformWPValues();
      return;
    }
    await this.fetchAndTransformValues();
  },
  methods: {
    async fetchAndTransformValues(): Promise<void> {
      if(this.isWPValue(this.values)) {
        return;
      }
      const promises: Promise<IMediaElementDto>[] = [];
      for(const value of this.values) {
        promises.push(this.mockFetchRequest(value.iconMediaId));
      }
      this.transformedValues = await Promise.all(promises);
    },
    isWPValue(data: IValuesSectionData[] | IWPValue[]): data is IWPValue[] {
      return (data[0] as IWPValue).image !== undefined;
    },
    // eslint-disable-next-line @typescript-eslint/no-unused-vars-experimental
    async mockFetchRequest(id: number): Promise<IMediaElementDto> {
      const mockDate = new Date();
      return {
        mediaItem: {
          altText: `mockedAltText`,
          caption: `mockedCaption`,
          categories: [
            {
              id: 0,
              name: `mockedName`,
            },
          ],
          createdAt: mockDate,
          createdBy: 1,
          description: `mockedDescription`,
          height: 100,
          id: 1,
          title: `mockedTitle`,
          type: EMediaType.IMAGE,
          updatedAt: mockDate,
          updatedBy: 1,
          width: 100,
        },
        mediaUrls: [
          {
            fileName: `mockedFileName`,
            fileUrl: `mockedFileURL`,
            language: ELanguage.DE,
            s3Key: `mockedS3Key`,
          },
        ],
      };
    },
    transformWPValues(): void {
      if(!this.isWPValue(this.values)) {
        return;
      }

      const mockDate = new Date();
      this.transformedValues = this.values.map(value => {
        const label = this.$t(`products-ufe:${value.locizeKey}`);
        return {
          mediaItem: {
            altText: `${label} image`,
            caption: `mockedCaption`,
            categories: [
              {
                id: 0,
                name: `mockedName`,
              },
            ],
            createdAt: mockDate,
            createdBy: 1,
            description: `mockedDescription`,
            height: 100,
            id: 1,
            title: `mockedTitle`,
            type: EMediaType.IMAGE,
            updatedAt: mockDate,
            updatedBy: 1,
            width: 100,
          },
          mediaUrls: [
            {
              fileName: `${value.image}`,
              fileUrl: value.image,
              language: ELanguage.DE,
              s3Key: `mockedS3Key`,
            },
          ],
        };
      });
    },
  },
});
